// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3qJup","inner":"Footer_inner__2EBrh"};